import { Checkbox } from "antd";
import { ClockCircleOutlined, TeamOutlined, UserOutlined } from "@ant-design/icons";
import { fmtTimeHM } from "../../extensions/utils";
import { isMobile } from "@/extensions/design";
import { SportTooltip } from "@/controls";

const VisitItem = ({ item, onClick }) => {
  const penaltyVid = Number(item.penaltyVid ?? item.PenaltyVid ?? 0);
  const timePenalty = Number(item.timePenalty ?? item.TimePenalty ?? 0);

  const getImage = () => {
    if (item.recordId) return <img src="/images/calendar.svg" alt="record"/>
    if (item.imageId) return <img src={`${process.env.REACT_APP_API_BASE_URL}/api/image/${item.imageId}.jpg`} alt="client" className={isMobile ? "client-photo" : ""}/>
    return <img src={item.clientId ? "/images/card.svg" : "/images/mask.svg"} alt="client"/>
  }

  return<div className="client-item" onClick={onClick}>
    <div className="client-item-photo">{getImage()}</div>
      <div className="visit-item-body">
        <div className="visit-item-line1">
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <div className="vitis-item-clip" style={{fontWeight: 600}}>{item.clientName}</div>
            {item.isRepresentative && (
              <SportTooltip title="Представитель группы" placement="top" getPopupContainer={() => document.body}>
                <span className="client-role-icon client-role-icon_representative">
                  <TeamOutlined />
                </span>
              </SportTooltip>
            )}
            {item.isFamilyMember && (
              <SportTooltip title="Участник группы" placement="top" getPopupContainer={() => document.body}>
                <span className="client-role-icon client-role-icon_family">
                  <UserOutlined />
                </span>
              </SportTooltip>
            )}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <div className="vitis-item-clip" style={{textAlign: "center"}}><Checkbox checked={item.finish} /></div>
            <div style={{textAlign: "center", fontWeight: 600}}>{fmtTimeHM(item.start)}</div>
          </div>
        </div>
        <div className="visit-item-line2">
          <div># {item.id}</div>
          <div className="vitis-item-clip">
            {item.productName}{item.cardCode ? ` · Доп. карта ${item.cardCode}` : ""}
          </div>
        <div className="visit-item-times">
          <span>{item.keyName}</span>
          {timePenalty ? <span className={`visit-time-penalty visit-time-penalty-${penaltyVid}`}><ClockCircleOutlined /></span> : null}
        </div>
      </div>
    </div>
  </div>
}

export default VisitItem;
